import { render } from "./SportPage.vue?vue&type=template&id=45631445&scoped=true"
import script from "./SportPage.vue?vue&type=script&lang=js"
export * from "./SportPage.vue?vue&type=script&lang=js"

import "./SportPage.vue?vue&type=style&index=0&id=45631445&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45631445"]])

export default __exports__